const $ = kendo.jQuery

function getGridColumns() {
  const columns = [
    {
      title: ' ',
      width: '50px',
      attributes: {
        style: 'text-align: center;',
      },
      template: function(item) {
        return `<input type="checkbox" class="checkboxDrawDown_${item.operationId}"/>`
      },
    },
    {
      title: ' ',
      width: '61px',
      attributes: {
        style: 'text-align: center;',
      },
      template:
        '<a title="Open Deal" href="javascript:;" class="dealLink fas fa-external-link-alt"></a>',
    },
    {
      field: 'number',
      title: 'Number',
      width: '100px',
      attributes: {
        style: 'text-align: center;',
      },
      template: function(item) {
        return `<a title="Delivery Schedule" href="javascript:;" class="deliveryScheduleLink k-cellLink">${
          item.number
        }</a>`
      },
    },
    {
      field: 'sector',
      title: 'Sector',
      width: 150,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'division',
      title: 'Division',
      width: 150,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'counterparty',
      title: 'Counterparty',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'reference',
      title: 'Reference',
      width: 180,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'undeliveredAmount',
      title: 'Undelivered Amount',
      format: '{0:n0}',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
      aggregates: "['sum']",
      footerTemplate:
        "<div style='text-align: right'>#=kendo.toString(data.undeliveredAmount.sum, 'n0') # </div>",
    },
    {
      field: 'description',
      title: 'Description',
      width: 300,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'product',
      title: 'Product',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'leg',
      title: 'Leg',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'tradeDate',
      title: 'TradeDate',
      format: '{0:yyyy-MM-dd}',
      width: 100,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'startDate',
      title: 'StartDate',
      format: '{0:yyyy-MM-dd}',
      width: 100,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'hedgeMonth',
      title: 'Hedge Month',
      format: '{0:yyyy-MM-dd}',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'maturityDate',
      title: 'Maturity',
      format: '{0:yyyy-MM-dd}',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'settlementDate',
      title: 'Settlement',
      format: '{0:yyyy-MM-dd}',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'buySell',
      title: 'Buy/Sell',
      width: 75,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'hedgeAmount',
      title: 'Hedge Amount',
      template:
        "<div style='text-align: right'>#=kendo.toString(Math.abs(data.hedgeAmount), 'n0') # </div>",
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'ccy1',
      title: 'Com.Ccy',
      width: 80,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'hedgeRate',
      title: 'Hedge Rate',
      format: '{0:n4}',
      width: 100,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'amountCcy2',
      title: 'Amount Ccy',
      format: '{0:n0}',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'ccy2',
      title: 'Ccy',
      width: 80,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'hedgeType',
      title: 'Hedge Type',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'isExcercised',
      title: 'Excercised',
      width: 90,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'referenceRate',
      title: 'ReferenceRate',
      width: 140,
      format: '{0:n4}',
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'forwardPoints',
      title: 'Forward Points',
      width: 140,
      format: '{0:n4}',
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'gainLoss',
      title: 'Gain/Loss',
      width: 140,
      format: '{0:n2}',
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'optionType',
      title: 'Option',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'otherBarrier',
      title: 'Other Barrier',
      width: 100,
      format: '{0:n2}',
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'settlementMethod',
      title: 'Settlement Method',
      width: 90,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'settlementCcy',
      title: 'Settlement Ccy',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'lastModified',
      title: 'Last Modified',
      width: 161,
      format: '{0:yyyy-MM-dd hh:mm:ss}',
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'lastUser',
      title: 'Last User',
      width: 232,
      attributes: {
        style: 'text-align: left;',
      },
    },
  ]

  return [...columns]
}

function getClientsWithBalance(options) {
  return new Promise(function(resolve, reject) {
    const dataSourceUrl = '/api/report/ExposureReport/getClientsWithBalance'
    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const clients = response
        resolve(clients)
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

function renderClientContainers($container, options, renderLocation) {
  return new Promise(function(resolve) {
    getClientsWithBalance(options).then(function(clients) {
      let promiseArray = []
      let currentResponsible = null

      clients.forEach(
        ({
          clientId,
          clientName,
          ccyPairId,
          ccyPair,
          responsible,
          status,
          forwardOptionId,
          commentId,
          comments,
        }) => {
          if (currentResponsible !== responsible) {
            if (responsible) {
              $container.append(`<h3 style="margin-top:14px;">Responsible: ${responsible}</h3>`)
            }
            currentResponsible = responsible
          }

          options.clientId = clientId
          options.clientName = clientName
          options.ccyPairId = ccyPairId
          options.ccyPair = ccyPair
          options.status = status
          options.forwardOptionId = forwardOptionId
          options.commentId = commentId
          options.comments = comments
          $container.append(`<div id="clientContainer_${clientId}_${ccyPairId}"></div>`)
          let $clientContainer = $(`#clientContainer_${clientId}_${ccyPairId}`, $container)
          promiseArray.push(renderGrid($clientContainer, options, renderLocation))
        },
      )

      Promise.all(promiseArray).then(() => {
        resolve()
      })
    })
  })
}

function renderGrid($container, options, renderLocation) {
  const gridOptions = options
  const clientId = options.clientId
  const clientName = options.clientName
  const ccyPairId = options.ccyPairId
  const ccyPair = options.ccyPair
  const status = options.status
  const commentId = options.commentId
  const comments = options.comments
  const optionForwardId = options.forwardOptionId
  const optionForward = options.forwardOptionId == 1 ? 'Option' : 'Forward'

  return new Promise(function(resolve, reject) {
    let promiseGridArray = []
    const actionName =
      renderLocation == 'report'
        ? 'undeliveredBalanceDataSource'
        : 'undeliveredBalanceDataSourceComponent'
    const controllerName = 'ExposureReport'
    const dataSourceUrl = `/api/report/${controllerName}/${actionName}`

    $.ajax({
      url: dataSourceUrl,
      data: gridOptions,
      success: function(response) {
        const data = response
        if (data.length > 0) {
          $container.append(`<div id="gridContainer_${clientId}_${ccyPairId}"></div>`)
          const $gridContainer = $(`#gridContainer_${clientId}_${ccyPairId}`, $container)
          promiseGridArray.push(
            makeGrid(
              $gridContainer,
              clientId,
              clientName,
              ccyPairId,
              ccyPair,
              optionForward,
              optionForwardId,
              data,
              renderLocation,
              status,
              commentId,
              comments,
            ),
          )
        }

        Promise.all(promiseGridArray).then(() => {
          resolve()
        })
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

function makeGrid(
  $container,
  clientId,
  clientName,
  ccyPairId,
  ccyPair,
  optionForward,
  optionForwardId,
  data,
  renderLocation,
  status,
  commentId,
  comments,
) {
  return new Promise(function(resolve) {
    const showComment = commentId != 0 ? 'display:inline' : 'display:none'
    $container.append(`<div style="margin-top:14px;">
                          <input type="checkbox" class="checkAll" data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}" />
                          <span style="font-size:20px;font-weight:bold;padding-left:10px">${clientName}</span>
                          <button title="Drawdown" class="buttonDrawdown k-button-icon k-button" data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}">
                            <i class="buttonDrawdown fas fa-chart-line" data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}"></i>
                          </button>
                          <button title="Mail Undelivered Balance Report"
                                  id="sendUndeliveredForm_${clientId}_${ccyPairId}_${optionForwardId}_button"
                                  class="undeliveredMail k-button-icon k-button ${status}"
                                  data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}" data-sendinglistid="${commentId}">
                             <i class="undeliveredMail fa fa-paper-plane" data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}"></i>
                          </button>
                          <button id="key_${clientId}_${ccyPairId}_${optionForwardId}_button" title="Save comments" data-id="${commentId}" data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}" class="buttonSaveComments k-button-icon k-button">
                            <i id="key_${clientId}_${ccyPairId}_${optionForwardId}_icon" data-id="${commentId}"data-clientid="${clientId}" data-ccypairid="${ccyPairId}" data-optionforwardid="${optionForwardId}" class="buttonSaveComments fas fa-save"></i>
                          </button>
                          <textarea id="comments_${clientId}_${ccyPairId}_${optionForwardId}_textBox" title="Comments" class="k-textbox" style="height:50px;width:582px;${showComment}">${comments}</textarea>
                       </div>`)
    $container.append(`<h3> ${ccyPair}  ${optionForward}</h3>`)
    $container.append(`<div id="clientGrid_${clientId}_${ccyPairId}_${optionForwardId}">Kr</div>`)
    $container.append('<div class="page-break"/>')
    let $clientContainer = $(`#clientGrid_${clientId}_${ccyPairId}_${optionForwardId}`, $container)
    const grid = $clientContainer
      .empty()
      .kendoGrid({
        editable: false,
        scrollable: true,
        autoBind: false,
        dataSource: {
          data: data,
          aggregate: [
            {
              field: 'undeliveredAmount',
              aggregate: 'sum',
            },
          ],
          schema: {
            model: {
              id: 'number',
              fields: {
                number: {type: 'string'},
                operationId: {type: 'number'},
                status: {type: 'string'},
                sector: {type: 'string'},
                hedgeType: {type: 'string'},
                division: {type: 'string'},
                counterparty: {type: 'string'},
                leg: {type: 'string'},
                product: {type: 'string'},
                startDate: {type: 'date'},
                tradeDate: {type: 'date'},
                settlementDate: {type: 'date'},
                maturityDate: {type: 'date'},
                hedgeMonth: {type: 'date'},
                buySell: {type: 'string'},
                undeliveredAmount: {type: 'number'},
                amountCcy1: {type: 'number'},
                hedgeAmount: {type: 'number'},
                gainLoss: {type: 'number'},
                ccy1: {type: 'string'},
                hedgeRate: {type: 'string'},
                collarRate: {type: 'string'},
                amountCcy2: {type: 'number'},
                otherBarrier: {type: 'number'},
                ccy2: {type: 'string'},
                description: {type: 'string'},
                reference: {type: 'string'},
                isExercised: {type: 'string'},
                lastModified: {type: 'date'},
                lastUser: {type: 'string'},
                isFuture: {type: 'bool'},
                canDrawDown: {type: 'bool'},
              },
            },
          },
        },
        dataBound: function(e) {
          if (renderLocation === 'dashboard') {
            const items = e.sender.dataSource.data().length
            if (items == 0) {
              e.sender.element.closest('.component').remove()
            }
            if (items > 25) {
              e.sender.element.closest('.component').prepend('<div class="page-break"/>')
            }
          } else {
            var gridData = e.sender.dataSource.view()
            var grid = $(e.sender.element)
            gridData.forEach(dataItem => {
              var row = grid.find("tr[data-uid='" + dataItem.uid + "']")
              if (!dataItem.canDrawDown) {
                row.find('input[type=checkbox]').addClass('hidden')
              }
            })
          }
          resolve(grid)
        },
        filterable: false,
        sortable: false,
        pageable: false,
        columns: getGridColumns(),
      })
      .data('kendoGrid')

    grid.dataSource.read().then(function() {
      setTimeout(function() {
        grid.dataSource.filter([])
      }, 132)
    })
  })
}

$(document)
  .off('change', '.checkAll')
  .on('change', '.checkAll', function(e) {
    const isChecked = $(this).is(':checked')
    const clientId = +e.target.dataset.clientid
    const ccyPairId = +e.target.dataset.ccypairid
    const optionForwardId = +e.target.dataset.optionforwardid
    $(`#clientGrid_${clientId}_${ccyPairId}_${optionForwardId}`)
      .data('kendoGrid')
      .dataSource.view()
      .forEach(function(el) {
        let checkbox = $('input:checkbox.checkboxDrawDown_' + el.operationId)
        checkbox.prop('checked', !isChecked)
        checkbox.click()
      })
  })

export default {
  render: function($container, options, location = 'dashboard') {
    return renderClientContainers($container, options, location)
  },
}
